import React from "react";
import { TABLES } from "../../Utils/tableConst"
import { Table } from "../Table"

export const TableQuery1 = () => (<Table tableData={TABLES.QUERY_1} theme='default' />);